<div class="row">
    <div class="col-12">
      <div class="content-header">Add Routes Form</div>
    </div>
  </div>
  <!-- Basic Inputs start -->
  <section id="basic-input">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- <div class="card-header">
                      <h4 class="card-title">Basic</h4>
                  </div> -->
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-md">
                  <form [formGroup]="routesForm">
                    <fieldset class="form-group">
                      <label>Path</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="path"
                        id="path"
                        placeholder="Enter path"
                        [ngClass]="{
                          'is-invalid': routesFormSubmitted && rf.path.invalid,
                          'is-valid': routesFormSubmitted && !rf.path.invalid
                        }"
                        required
                      />
                      <div
                        *ngIf="
                          rf.path.touched &&
                          (rf.path.invalid || rf.path.errors?.required)
                        "
                        class="help-block mt-1 text-danger"
                      >
                        <i class="ft-alert-circle align-middle"></i> path is
                        required
                      </div>
                    </fieldset>
        
                  </form>
                </div>
                <div class="col-md">
                  <form [formGroup]="routesForm">
                    <fieldset class="form-group">
                        <label>Title</label>
                        <input
                          type="text"
                          class="form-control"
                          formControlName="title"
                          id="title"
                          placeholder="Enter title"
                          [ngClass]="{
                            'is-invalid': routesFormSubmitted && rf.title.invalid,
                            'is-valid': routesFormSubmitted && !rf.title.invalid
                          }"
                          required
                        />
                        <div
                          *ngIf="
                            rf.title.touched &&
                            (rf.title.invalid || rf.title.errors?.required)
                          "
                          class="help-block mt-1 text-danger"
                        >
                          <i class="ft-alert-circle align-middle"></i> title is
                          required
                        </div>
                      </fieldset>
                    <div
                      class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                    >
                      <button
                        type="submit"
                        class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                        (click)="submit()"
                      >
                        Submit
                      </button>
                      <button
                        type="reset"
                        class="btn btn-secondary"
                        (click)="back()"
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  